import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalFlex, PadContainer } from 'smartsuite-ui';
import { useLabelContext } from '../../../../../shared/hooks/labelContext';

export default function NationalSummary(props) {
    const { dashboardLabels } = useLabelContext();
    const { onTarget, offTarget } = props.data;
    const total = onTarget + offTarget;

    return (
        <div className="national-summary">
            <div className="national-summary__legend">
                <span>
                    {dashboardLabels.totalKpis}: <b>{total}</b>
                </span>
                <HorizontalFlex cssClassModifiers={['align-baseline']}>
                    <div className="national-summary__legend-color national-summary__legend-color--green" />
                    <span>
                        {dashboardLabels.onTarget}: <b>{onTarget}</b>
                    </span>
                </HorizontalFlex>
                <HorizontalFlex cssClassModifiers={['align-baseline']}>
                    <div className="national-summary__legend-color national-summary__legend-color--red" />
                    <span>
                        {dashboardLabels.offTarget}: <b>{offTarget}</b>
                    </span>
                </HorizontalFlex>
            </div>
            <PadContainer cssClassModifiers={['pad-small']} />
            <div className="national-summary__bar">
                <div
                    className="national-summary__bar-on-target"
                    style={{ width: `${(onTarget / total) * 100}%` }}
                />
                <div
                    className="national-summary__bar-off-target"
                    style={{ width: `${(offTarget / total) * 100}%` }}
                />
            </div>
        </div>
    );
}

NationalSummary.propTypes = {
    data: PropTypes.instanceOf(Object).isRequired,
};
